module.exports = __webpack_public_path__ + "static/media/19ESCAP9.8aee49c2.jpg";